export const LOCATION_ORG_FETCH_ALL = 'LOCATION_ORG_FETCH_ALL';
export const LOCATION_ORG_FETCH_ALL_INIT = 'LOCATION_ORG_FETCH_ALL_INIT';
export const LOCATION_ORG_FETCH_ALL_DONE = 'LOCATION_ORG_FETCH_ALL_DONE';

export const LOCATION_ORG_CLEAR = 'LOCATION_ORG_CLEAR';
